import React, { Component } from "react";
//PrimeReact Components
import * as pr from "../../common/PrimeComponents";
//Common
import { LoadScreen } from "../../common/LoadScreen";
import { api } from "../../common/ApiPromisify";
//ClientLibsReference
import { Belfastpilatesappspotcom } from "../../common/ClientLibsReference";

export class CreateClass extends Component {
  constructor() {
    super();
    this.state = {
      loaded: false,
      instructorList: "",
      newClassInstructors: "",
      newClassSetId: "",
      newClassSetServiceId: "",
      newClassDate: "",
      newClassStartTime: "",
      newClassEndTime: "",
      pickListAvailable: [],
      pickListSelected: [],
      roomList: [],
      roomOptions: [],
      selectedRoom: "",
    };
  }

  componentDidMount = () => {
    this.setState(
      {
        newClassSetId: localStorage.getItem("selectedSetId"),
        newClassSetServiceId: localStorage.getItem("selectedSetServiceId"),
      },
      () => {
        localStorage.removeItem("selectedSetId");
        localStorage.removeItem("selectedSetServiceId");
      }
    );

    this.getRooms();
    this.getInstructors();
  };

  getRooms = async () => {
    let roomRequest = new Belfastpilatesappspotcom.RoomRequest();
    roomRequest.codeTag = localStorage.getItem("globalBid");

    await api("roomApiV1RoomGetByCodeTag", roomRequest).then((res) => {
      if (res.data) {
        if (res.data.lastUpdatedDateTime) {
          res.data.lastUpdatedDateTime = res.data.lastUpdatedDateTime.toJSON();
        }

        let roomResponse =
          Belfastpilatesappspotcom.RoomResponse.constructFromObject(res.data);
        console.log(roomResponse);

        if (roomResponse.errorCode === 0) {
          this.setState(
            {
              roomList: roomResponse.roomList,
            },
            () => {
              this.roomsToOptions(roomResponse.roomList);
            }
          );
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail:
              "Rooms could not be retrieved, please refresh and try again",
            life: 3000,
          });
        }
      } else {
        console.log("roomApiV1RoomGetByCodeTag has failed");
      }
    });
  };

  roomsToOptions = (array) => {
    let roomArray = [];

    let roomList = this.state.roomList;
    if (Array.isArray(array)) {
      roomList = array;
    }

    if (Array.isArray(this.state.roomList)) {
      this.state.roomList.forEach((e) => {
        roomArray.push({ label: e.name, value: e.id });
      });
    }

    this.setState({ roomOptions: roomArray });
  };

  getInstructors = async () => {
    this.setState({ loaded: false });

    let userRequest = new Belfastpilatesappspotcom.UserRequest();
    userRequest.codeTag = localStorage.getItem("globalBid");

    await api("userApiV1UserListInBusiness", userRequest).then((res) => {
      if (res.data) {
        if (res.data.lastUpdatedDateTime) {
          res.data.lastUpdatedDateTime = res.data.lastUpdatedDateTime.toJSON();
        }

        let userResponse =
          Belfastpilatesappspotcom.UserResponse.constructFromObject(res.data);
        console.log(userResponse);

        if (userResponse.errorCode === 0) {
          this.setState({
            instructorList: userResponse.users,
            pickListAvailable: userResponse.users,
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail:
              "Instructors could not be retrieved, please refresh and try again",
            life: 3000,
          });
        }
      } else {
        console.log("userApiV1UserListInBusiness has failed");
      }
    });

    this.setState({ loaded: true });
  };

  createClass = async (ids) => {
    if (
      !this.state.newClassDate ||
      !this.state.newClassStartTime ||
      !this.state.newClassEndTime
    ) {
      this.growl.show({
        severity: "error",
        summary: "Missing Fields",
        detail: "Please fill in all fields",
        life: 3000,
      });
    } else {
      let idArray = [];

      let bookRequest = new Belfastpilatesappspotcom.BookRequest();
      bookRequest.codeTag = localStorage.getItem("globalBid");
      bookRequest.userId = localStorage.getItem("userId");
      bookRequest.setId = this.state.newClassSetId;
      bookRequest.serviceId = this.state.newClassSetServiceId;
      bookRequest.roomId = this.state.selectedRoom;
      bookRequest.date = this.state.newClassDate;
      bookRequest.startTime = this.formatDateValue(
        this.state.newClassStartTime
      );
      bookRequest.endTime = this.formatDateValue(this.state.newClassEndTime);
      bookRequest.identifier = "CREATE";
      if (ids) {
        bookRequest.instructorIds = ids;
      }
      if (Array.isArray(this.state.pickListSelected)) {
        this.state.pickListSelected.forEach((e) => {
          idArray.push(e.id);
        });
        bookRequest.instructorIds = idArray;
      }

      await api("bookApiV1BookCreateUpdateSet", bookRequest).then((res) => {
        if (res.data) {
          let bookResponse =
            Belfastpilatesappspotcom.BookResponse.constructFromObject(res.data);
          console.log(bookResponse);

          if (bookResponse.errorCode === 0) {
            window.location = "/#/managesets";
          } else {
            this.growl.show({
              severity: "error",
              summary: "Error",
              detail: "Class could not be created, please try again",
              life: 3000,
            });
          }
        } else {
          console.log("bookApiV1BookCreateUpdateSet has failed");
        }
      });
    }
  };

  formatDateValue = (date) => {
    let reformattedDate = "";
    let theDate = new Date();
    let currentMonth = theDate.getMonth();

    if (
      currentMonth === 4 ||
      currentMonth === 5 ||
      currentMonth === 6 ||
      currentMonth === 7 ||
      currentMonth === 8 ||
      currentMonth === 9
    ) {
      reformattedDate = (
        parseInt(JSON.stringify(date).slice(12, 17).replace(":", ""), 10) + 100
      ).toString();
    } else {
      reformattedDate = parseInt(
        JSON.stringify(date).slice(12, 17).replace(":", ""),
        10
      ).toString();
    }

    return reformattedDate;
  };

  render() {
    if (!this.state.loaded) {
      return (
        <center>
          <pr.Growl
            style={{ textAlign: "left" }}
            ref={(el) => (this.growl = el)}
          />
          <LoadScreen />
        </center>
      );
    }
    return (
      <div className="ui-g">
        <div className="ui-g-12">
          <pr.Growl
            style={{ textAlign: "left" }}
            ref={(el) => (this.growl = el)}
          />
          <div className="card">
            <div className="ui-g">
              <div className="ui-g-12">
                <h1>Create New Class</h1>
                <div className="ui-g-6 ui-g-nopad">
                  <div className="ui-g-12">
                    <pr.Calendar
                      dateFormat="dd/mm/yy"
                      placeholder="Date"
                      value={this.state.newClassDate}
                      showSeconds={true}
                      showSeconds={true}
                      onChange={(e) => {
                        let date = new Date(
                          Date.UTC(
                            e.value.getFullYear(),
                            e.value.getMonth(),
                            e.value.getDate()
                          )
                        );

                        this.setState({ newClassDate: date });
                      }}
                    />
                  </div>
                  <div className="ui-g-12" style={{ paddingTop: "20px" }}>
                    <pr.Calendar
                      value={this.state.newClassStartTime || ""}
                      onChange={(e) => {
                        this.setState({ newClassStartTime: e.value });
                      }}
                      timeOnly={true}
                      hourFormat="24"
                      inputStyle={{
                        width: "100%",
                      }}
                      placeholder="Start Time"
                    />
                  </div>
                  <div className="ui-g-12" style={{ paddingTop: "20px" }}>
                    <pr.Calendar
                      value={this.state.newClassEndTime || ""}
                      onChange={(e) => {
                        this.setState({ newClassEndTime: e.value });
                      }}
                      timeOnly={true}
                      hourFormat="24"
                      inputStyle={{
                        width: "100%",
                      }}
                      placeholder="End Time"
                    />
                  </div>
                  <div className="ui-g-12" style={{ paddingTop: "20px" }}>
                    <label>Room for Class: </label>
                    <br />
                    <pr.Dropdown
                      value={this.state.selectedRoom}
                      options={this.state.roomOptions}
                      onChange={(e) => {
                        this.setState({ selectedRoom: e.value });
                      }}
                    />
                  </div>
                </div>
                <div className="ui-g-6">
                  <div className="ui-g-12">
                    <label>Instructor(s): </label>
                    <br />
                    <br />
                    <pr.PickList
                      source={this.state.pickListAvailable || []}
                      target={this.state.pickListSelected || []}
                      sourceHeader="Available"
                      targetHeader="Selected"
                      responsive={true}
                      itemTemplate={(e) => (
                        <span>{e.firstName + " " + e.surname}</span>
                      )}
                      onChange={(e) => {
                        this.setState({
                          pickListAvailable: e.source,
                          pickListSelected: e.target,
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="ui-g-12">
                <pr.Button
                  label="Create Class"
                  onClick={() => {
                    this.createClass();
                  }}
                  style={{ float: "right" }}
                />
                <pr.Button
                  label="Cancel"
                  onClick={() => {
                    window.location = "#/managesets";
                  }}
                  style={{ float: "right" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Sets/CreateClass.js